import _ from "lodash";
import styled from "styled-components";

import SVGLightBulbIcon from "./components/SVGLightBulbIcon";

const SafeConnectLeiBannerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f7e8e9;
  width: 100%;
  height: 40px;
  margin-right: 17px;
  padding: 10px;
  user-select: none;
  cursor: pointer;
  border-radius: 4px;
`;

const ContentContainer = styled.div`
  display: flex;
  column-gap: 10px;
  padding: 10px 0px;
  align-items: center;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
`;

const DescriptionContainer = styled.div`
  font-size: 9px;
  font-weight: 700;
`;

type SafeConnectRequiredFieldsBannerProps = {
  description?: string;
};

export default function SafeConnectRequiredFieldsBanner({
  description = "Fill out required fields to generate your Due Diligence Questionnaire for Travel Rule Data Sharing",
}: SafeConnectRequiredFieldsBannerProps) {
  return (
    <SafeConnectLeiBannerContainer>
      <ContentContainer>
        <IconContainer>
          <SVGLightBulbIcon style={{ cursor: "pointer" }} data-testid="light-bulb-icon" />
        </IconContainer>
        <DescriptionContainer>{description}</DescriptionContainer>
      </ContentContainer>
    </SafeConnectLeiBannerContainer>
  );
}
